import { useState } from "react";
import { CloudDownload, LoaderCircle, CircleCheck } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { downloadTopics } from "@/lib/offlineContent";
import { useOnline } from "@/hooks/useOnline";

export const DownloadCard = ({ lang, level, onDone }) => {
  const online = useOnline();
  const [status, setStatus] = useState("");
  const start = level.topics.findIndex((t) => t.status === "current");
  const upcoming = start >= 0 ? level.topics.slice(start, start + 3) : [];

  const run = async () => {
    try {
      const n = await downloadTopics(lang, level, upcoming, setStatus);
      toast.success(`${n} topic${n > 1 ? "s" : ""} ready for offline, including audio`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setStatus("");
    }
  };

  if (!upcoming.length) return null;
  return (
    <div data-testid="download-card" className="rounded-2xl border-2 border-dashed border-slate-300 bg-white p-4">
      <p className="font-display font-bold text-slate-900 flex items-center gap-2"><CloudDownload size={18} /> Learn offline</p>
      <p className="text-xs text-slate-500 mt-1">Saves lessons, assessments and voice clips for: {upcoming.map((t) => t.title).join(", ")}.</p>
      <button data-testid="download-topics-button" onClick={run} disabled={!online || !!status} className="btn-ghost w-full mt-3 !py-2.5 text-sm">
        {status ? <><LoaderCircle size={16} className="animate-spin" /> {status}</> : <><CloudDownload size={16} /> Download next {upcoming.length} topics</>}
      </button>
      {!online && <p className="text-xs text-slate-500 mt-2">Connect to the internet to download.</p>}
    </div>
  );
};

export const SavedMark = () => (
  <span title="Available offline" className="absolute -top-1 -right-1 h-6 w-6 rounded-full bg-white grid place-items-center shadow">
    <CircleCheck size={16} className="text-[hsl(var(--accent-blue))]" />
  </span>
);
